import Vec2 from 'vec2';

import {
  ARROW_LENGTH_GRANULARITY_IN_INCHES,
  CORNER_RADIUS_ANGLE_GRANULARITY_IN_DEGREES,
} from '~/core/constants';

export const getTopLeftVector = (vectors: Array<Vec2>): Vec2 => {
  let topLeftVector = vectors[0];
  // -0.15 is fault tolerance on points coordinates
  const faultTolerance = 0.15;

  /*
 //Need to improve more
 vectors.forEach((v: Vec2) => {
     const diffY = Math.abs(tl.y) - Math.abs(v.y);
     if ((tl.y > 0 && v.y < 0) || (tl.y > v.y && (diffY > faultTolerance || diffY < -faultTolerance))) {
         tl = v;
     } else if (tl.x > 0 && v.x < 0) {
         tl = v;
     } else if (tl.x > v.x && diffY < faultTolerance) {
         const diffX = Math.abs(tl.x) - Math.abs(v.x);
         if (diffX > faultTolerance) {
             tl = v;
         }
     }
 });*/

  vectors.forEach((vector: Vec2) => {
    if (
      vector.y < topLeftVector.y - faultTolerance ||
      (Math.abs(vector.y - topLeftVector.y) < faultTolerance &&
        vector.x < topLeftVector.x)
    ) {
      topLeftVector = vector;
    }
  });

  return topLeftVector;
};

/**
 *
 * @param value value to be rounded
 * @param granularity the granularity to use when rounding. When zero, this function returns {@link value} unaltered
 * @returns the rounded value. When {@link granularity} is 0 returns {@link value}
 */
export const roundToNearest = (value: number, granularity: number): number =>
  granularity === 0 ? value : Math.round(value / granularity) * granularity;

export const roundToArrowLengthGranularity = (length: number): number =>
  roundToNearest(length, ARROW_LENGTH_GRANULARITY_IN_INCHES);

export const roundToCornerRadiusGranularity = (radius: number): number =>
  roundToNearest(radius, CORNER_RADIUS_ANGLE_GRANULARITY_IN_DEGREES);

export const convertFromRadiansToDegree = (angle: number): number =>
  (angle * 180.0) / Math.PI;

/**
 * clamps a value to (min <= value <= max).
 * @param value the input to check
 * @param min the minimum allowed value
 * @param max the maximum allowed value
 */
export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(value, max));
